import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { TranslocoDirective } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

import { LanguageService } from '../../../core/i18n';
import { getCurrentLanguage, setCurrentLanguage } from '../../store';

@Component({
    selector: 'bucke-change-language',
    templateUrl: './change-language.component.html',
    styleUrl: './change-language.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatRadioModule, TranslocoDirective],
})
export class ChangeLanguageComponent {
    private store = inject(Store);
    languages = inject(LanguageService).supportedLanguages;

    currentLanguage = this.store.selectSignal(getCurrentLanguage);
    form = new FormGroup({
        language: new FormControl(this.currentLanguage(), { nonNullable: true, validators: Validators.required }),
    });
    private matDialogRef = inject(MatDialogRef);

    onSubmit(): void {
        if (!this.form.valid) {
            return;
        }
        this.store.dispatch(setCurrentLanguage(this.form.getRawValue()));
        this.matDialogRef.close();
    }
}
